import React, { useEffect, useState } from 'react'
import './styles.scss';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../../Layout';
import { mixGetV2, mixPostV2, uploadMultipleFiles, uploadFileImportReview, mixGetV3, importFileStep4, mixDate, mixPostV3 } from '../../../services/mixin';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import { Steps, Spin, Modal, Checkbox } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import useToast from "../../../hook/useToast";
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';

const pushToast = useToast();

const AddAgencyModal: React.FC = ({
}) => {
  const user = useSelector(selectorInfoUser);
  const [currentStep, setCurrentStep] = useState(0)
  const navigate = useNavigate()
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [skipConfirm, setSkipConfirm] = useState(false)
  const [activeSession, setActiveSession] = useState<any>(null)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [showRollbackModal, setShowRollbackModal] = useState(false)
  const [sessionActionLoading, setSessionActionLoading] = useState(false)

  const [stData, setStData] = useState<any>({
    importHistory: [],
    fileTemplates: [],
    dataFiles: [],
    source: [],
    sourceColumns: [],
    expandedRowKey: null,
    showData: {
      columns: [],
      allList: [],
      update: [],
      new: [],
      dup: []
    },
    obSourceColumns: {},
    loading: false,
    listSelectStep4: [],
    obChoseStep4: {},
    obCheckRadioStep4: {},
    priorityFiles: [],
    tempParams: {},
    filesParams: {},
    listKeyStep4: ['o_type', 'warehouse_field_1', 'interest', 'unknown_field_42', 'birthday', 'address', 'district', 'source_channel'],
    paramMap: [],
    resData: {},
    task_id: '',
    step4Data: {},
    step4DataSelected: {},
    step5Data: {},
    reviewTaskId: '',
    reviewFiles: [],
    reviewTotalInvalid: 0,
  } as any);
  useEffect(() => {
    console.log('stData', stData);
  }, [stData]);
  useEffect(() => {
    mixGetV2('/api/v1/be/source_column_warehouses?is_active=1&category_source_group_id=3').then(res => {
      if (res.status) {
        const tempSourceColumns = [] as any
        const obTemp = {} as any
        res.data.items.map((val: any) => {
          const listSourceIds = [] as any
          val.params_key.map((val: any) => {
            listSourceIds.push(val.source_id)
            return true
          })
          const itemCreate = { id: val.id, name: val.name, json: val.json || '[]', column: val.column_warehouse.column, source_id: listSourceIds, type: val.type_id }
          tempSourceColumns.push(itemCreate)
          obTemp[val.column_warehouse.column] = itemCreate
          return true
        })
        setStData((prev: any) => ({ ...prev, sourceColumns: tempSourceColumns, obSourceColumns: obTemp }));

        mixGetV2('/api/v1/be/sources').then(resSource => {
          if (resSource.status) {
            const tempSource = [] as any
            const obSource = {} as any
            resSource.data.items.map((val: any) => {
              const sourceColumns = tempSourceColumns.filter((col: any) => col.source_id.includes(val.id));
              tempSource.push({ ...val, columns: sourceColumns, nameColumns: sourceColumns.map((col: any) => col.column) });
              obSource[val.id] = { ...val, columns: sourceColumns, nameColumns: sourceColumns.map((col: any) => col.name) };
              return true
            })
            setStData((prev: any) => ({ ...prev, source: tempSource, obSource }))
          }
        });
      }
    });
  }, []);

  const getParamMap = async () => {
    const res = await mixGetV2('/api/v1/be/setting_mapping?type=2')
    if (res.status) {
      setStData((prev: any) => ({ ...prev, paramMap: [...JSON.parse(res.data.value || '[]')] }))
    }
  }
  useEffect(() => {
    getParamMap()
  }, [])

  // ===== Phiên nhập liệu (1 phiên / admin) =====
  const checkActiveSession = async () => {
    if (!user.id) return
    try {
      const res = await mixGetV3('/import/file_import_session/active', { admin_id: user.id }, { skipVehicleBrand: true })
      if (res && res.has_active) {
        setActiveSession(res)
      } else {
        setActiveSession(null)
      }
    } catch (e) {
      setActiveSession(null)
    }
  }
  useEffect(() => {
    checkActiveSession()
  }, [user.id])

  // Review/Process trả 409 khi admin còn phiên dang dở → quay về bước 1 + hiện banner
  const handle409 = () => {
    setCurrentStep(0)
    checkActiveSession()
    pushToast("Bạn đang có một phiên nhập liệu chưa hoàn tất, vui lòng tiếp tục hoặc hủy phiên nhập liệu trước khi import tệp mới.", "warning")
  }

  // Lấy kết quả review theo task_id → vào bước 4 (dùng chung cho luồng thường và resume)
  const loadReviewResult = (task_id: string) => {
    mixGetV3(`/result/file_import_review/${task_id}`, { admin_id: user.id }, { skipVehicleBrand: true }).then((resultRes: any) => {
      if (resultRes && resultRes.status === 'SUCCESS' && resultRes.files) {
        const files = resultRes.files;
        const totalInvalid = files.reduce((sum: number, f: any) => sum + (f.error_count ?? 0), 0);
        setStData((prev: any) => ({
          ...prev,
          loading: false,
          reviewTaskId: resultRes.task_id || task_id,
          reviewFiles: files,
          reviewTotalInvalid: totalInvalid,
          reviewIsSkippable: resultRes.is_skippable !== false,
          reviewRequiredWarnings: resultRes.required_warnings || {},
        }));
        setCurrentStep(3);
      } else {
        setStData((prev: any) => ({ ...prev, loading: false }));
        pushToast("Đã có lỗi xảy ra khi lấy kết quả kiểm tra file.", "error");
      }
    });
  };

  const importReviewData = () => {
    setStData((prev: any) => ({ ...prev, loading: true }));
    uploadFileImportReview(stData.dataFiles.map((file: any) => file.file), user.id).then(res => {
      if (res && res.task_id) {
        // task_id sinh ở review — GIỮ id này dùng xuyên suốt mọi bước sau
        setStData((prev: any) => ({ ...prev, reviewTaskId: res.task_id }));
        pollReviewStatus(
          res.task_id,
          () => loadReviewResult(res.task_id),
          () => {
            setStData((prev: any) => ({ ...prev, loading: false }));
            pushToast("Đã có lỗi xảy ra trong quá trình kiểm tra file.", "error");
          }
        );
      } else {
        setStData((prev: any) => ({ ...prev, loading: false }));
        pushToast("Đã có lỗi xảy ra khi tải file lên.", "error");
      }
    }).catch((err: any) => {
      setStData((prev: any) => ({ ...prev, loading: false }));
      if (err && err.status === 409) {
        handle409();
      } else {
        pushToast("Đã có lỗi xảy ra khi tải file lên.", "error");
      }
    });
  };

  const pollReviewStatus = (task_id: string, onSuccess?: () => void, onError?: (err: any) => void) => {
    let intervalId: NodeJS.Timeout;
    const checkStatus = async () => {
      try {
        const res = await mixGetV3(`/status/file_import_review/${task_id}`, { admin_id: user.id }, { skipVehicleBrand: true });
        if (res.status === 'SUCCESS') {
          clearInterval(intervalId);
          if (onSuccess) onSuccess();
        } else if (res.status === 'FAILURE' || res.status === 'REVOKED') {
          clearInterval(intervalId);
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình kiểm tra file.", "error");
        } else if (res.status === 'PROGRESS' || res.status === 'PENDING' || res.status === 'STARTED') {
          console.log('Review task is still processing...');
        } else {
          clearInterval(intervalId);
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình kiểm tra file.", "error");
        }
      } catch (err) {
        clearInterval(intervalId);
        if (onError) onError(err);
      }
    };
    intervalId = setInterval(checkStatus, 5000);
    checkStatus();
  };

  // Lấy kết quả process theo task_id → vào bước 5 (dùng chung cho luồng thường và resume)
  const loadProcessResult = (task_id: string) => {
    getTaskResults(task_id).then((result) => {
      if (result && result.status) {
        if (result && result.data) {
          result.data = result.data.map((item: any) => ({
            ...item,
            key: item.idexist,
          }));
        }
        setStData((prev: any) => (
          {
            ...prev,
            step4Data: { ...result, task_id: result.task_id || task_id },
            loading: false,
            obCheckRadioStep4: {},
            listSelectStep4: [],
            step4DataSelected: {}
          }
        ));
        setCurrentStep(4);
      } else {
        setStData((prev: any) => ({ ...prev, loading: false }));
        pushToast("Đã có lỗi xảy ra khi lấy kết quả nhập dữ liệu.", "error");
      }
    });
  };

  const importData = () => {
    setStData((prev: any) => ({ ...prev, loading: true }));
    // Truyền task_id của review — 1 task_id xuyên suốt review → process → confirm
    uploadMultipleFiles(stData.dataFiles.map((file: any) => file.file), user.id, stData.reviewTaskId).then(res => {
      const taskId = (res && res.task_id) || stData.reviewTaskId;
      if (res && taskId) {
        pollTaskStatus(
          taskId,
          (data) => loadProcessResult(taskId),
          (err) => {
            setStData((prev: any) => ({ ...prev, loading: false }));
            pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
          }
        );
      } else {
        setStData((prev: any) => ({ ...prev, loading: false }));
        pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
      }
    }).catch((err: any) => {
      setStData((prev: any) => ({ ...prev, loading: false }));
      if (err && err.status === 409) {
        handle409();
      } else {
        pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
      }
    });
    return true
  }

  const getTaskResults = async (task_id: string) => {
    try {
      const res = await mixGetV3(`/result/file_import_process/${task_id}?offset=0&limit=10`, { admin_id: user.id }, { skipVehicleBrand: true });
      return res;
    } catch (error) {
      console.error('Error fetching task results:', error);
      return null;
    }
  };
  const pollTaskStatus = (task_id: string, onSuccess?: (data: any) => void, onError?: (err: any) => void) => {
    let intervalId: NodeJS.Timeout;
    const checkStatus = async () => {
      try {
        const res = await mixGetV3(`/status/file_import_process/${task_id}`, { admin_id: user.id }, { skipVehicleBrand: true });
        // PENDING_APPROVAL: đã xử lý xong, CHƯA ghi CRM — chờ Confirm/Reject ở bước 5
        if (res.status === 'SUCCESS' || res.status === 'PENDING_APPROVAL') {
          clearInterval(intervalId);
          if (onSuccess) onSuccess(res);
        } else if (res.status === 'FAILURE' || res.status === 'REVOKED') {
          setStData((prev: any) => ({ ...prev, loading: false }));
          clearInterval(intervalId);
          pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
        } else if (res.status === 'PROGRESS' || res.status === 'PENDING' || res.status === 'STARTED') {
          console.log('Task is still processing...');
        } else {
          clearInterval(intervalId);
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
        }
      } catch (err) {
        clearInterval(intervalId);
        if (onError) onError(err);
      }
    };
    intervalId = setInterval(checkStatus, 5000);
    checkStatus();
  };

  const importDataSave = async () => {
    // setStData((prev: any) => ({ ...prev, loading: true }));
    const jsonData = [] as any
    Object.keys(stData.step4DataSelected).map((itKey: any, index: any) => {
      const item = JSON.parse(JSON.stringify(stData.step4DataSelected[itKey]))
      // delete item.db_data
      const importData = {} as any
      Object.keys(item.import_data).map((key: any) => {
        if(key === 'customer_code_dict') {
          const tempx = {} as any
          Object.keys(item.import_data[key]).map((key2: any) => {
            if(stData.obCheckRadioStep4[`${itKey}_key_${key}_idval_${key2}`] !== undefined) {
              tempx[key2] = stData.obCheckRadioStep4[`${itKey}_key_${key}_idval_${key2}`]
            }
          })
          Object.keys(item.db_data[`${key}_exist`]).map((key2: any) => {
            if(stData.obCheckRadioStep4[`${itKey}_key_customer_code_dict_idval_${key2}`] !== undefined) {
              tempx[key2] = stData.obCheckRadioStep4[`${itKey}_key_customer_code_dict_idval_${key2}`]
            }
          })
          if (Object.keys(tempx).length > 0) {
            Object.keys(item.import_data[key]).map((key2: any) => {
              if(stData.obCheckRadioStep4[`${itKey}_key_${key}_idval_${key2}`] === undefined) {
                tempx[key2] = item.import_data[key][key2][1]
              }
            })
            importData[key] = {
              ...tempx
            };
          }

        } else {
          if (stData.obCheckRadioStep4[`${itKey}_key_${key}`]) {
            const arr = stData.obCheckRadioStep4[`${itKey}_key_${key}`].split('_');
            const x = {} as any
            x[arr[1]] = true
            importData[key] = {
              ...x
            };
          }
        }
      })

      if (Object.keys(importData).length > 0) {
        jsonData.push({
          status: item.status,
          idexist: item.idexist,
          record_index: item.record_index,
          data: importData
        })
      }
    })
    // 1 task_id xuyên suốt: ưu tiên id từ process, fallback id của review
    const confirmTaskId = stData.step4Data.task_id || stData.reviewTaskId
    const params = {
      task_id: confirmTaskId,
      data: jsonData,
      admin_id: user.id
    } as any
    try {
      const res = await mixPostV3('/import/file_import_result/json', params, { skipVehicleBrand: true })
      if (res) {
        pollTaskStatusSteep5(
          confirmTaskId,
          (data) => {
            setStData((prev: any) => ({ ...prev, loading: false, step5Data: res }));
            setCurrentStep(5);
            upHistory()
          })
      } else {
        setStData((prev: any) => ({ ...prev, loading: false }));
        pushToast("Đã có lỗi xảy ra khi xác nhận dữ liệu.", "error");
      }
    } catch (err: any) {
      setStData((prev: any) => ({ ...prev, loading: false }));
      pushToast("Đã có lỗi xảy ra khi xác nhận dữ liệu.", "error");
    }
    return true
  }

  const pollTaskStatusSteep5 = (task_id: string, onSuccess?: (data: any) => void, onError?: (err: any) => void) => {
    let intervalId: NodeJS.Timeout;
    const checkStatus = async () => {
      try {
        const res = await mixGetV3(`/import/file_import_result/status/${task_id}`, { admin_id: user.id }, { skipVehicleBrand: true });
        if (res.status === 'SUCCESS' || res.status === 'APPLIED') {
          clearInterval(intervalId);
          if (onSuccess) onSuccess(res);
        } else if (res.status === 'FAILURE' || res.status === 'REVOKED') {
          setStData((prev: any) => ({ ...prev, loading: false }));
          clearInterval(intervalId);
          pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
        } else if (res.status === 'PROGRESS' || res.status === 'PENDING' || res.status === 'STARTED') {
          console.log('Task is still processing...');
        } else {
          clearInterval(intervalId);
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
        }
      } catch (err) {
        clearInterval(intervalId);
        if (onError) onError(err);
      }
    };
    intervalId = setInterval(checkStatus, 5000);
    checkStatus();
  };

  // "Tiếp tục" phiên dang dở: phase=awaiting_confirm → nhảy thẳng bước 5;
  // phase=processing → poll status theo bước đang xử lý rồi vào bước tương ứng
  const resumeSession = () => {
    if (!activeSession || !activeSession.task_id) return
    const tid = activeSession.task_id
    const ses0 = (activeSession.sessions && activeSession.sessions[0]) || {}
    const stepNum = parseInt(`${ses0.step ?? activeSession.step ?? 4}`, 10)
    const phase = activeSession.phase
    setActiveSession(null)
    setStData((prev: any) => ({ ...prev, loading: true, reviewTaskId: tid }))
    if (phase === 'awaiting_confirm') {
      loadProcessResult(tid)
    } else if (stepNum >= 5) {
      pollTaskStatus(
        tid,
        () => loadProcessResult(tid),
        () => {
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình nhập dữ liệu.", "error");
        }
      )
    } else {
      pollReviewStatus(
        tid,
        () => loadReviewResult(tid),
        () => {
          setStData((prev: any) => ({ ...prev, loading: false }));
          pushToast("Đã có lỗi xảy ra trong quá trình kiểm tra file.", "error");
        }
      )
    }
  }

  // "Hủy" phiên: POST reject → REJECTED, nhả khóa phiên, CRM không đổi
  const rejectSession = async (task_id: any) => {
    if (!task_id || sessionActionLoading) return false
    setSessionActionLoading(true)
    try {
      await mixPostV3('/import/file_import_reject', { task_id, admin_id: user.id }, { skipVehicleBrand: true })
      pushToast("Đã hủy phiên nhập liệu.", "success")
      setActiveSession(null)
      checkActiveSession()
      return true
    } catch (e) {
      pushToast("Đã có lỗi xảy ra khi hủy phiên nhập liệu.", "error")
      return false
    } finally {
      setSessionActionLoading(false)
    }
  }

  // Nút "Hủy" ở bước 5: hủy phiên hiện tại → về bước 1 bắt đầu lại
  const handleCancelCurrentSession = async () => {
    const tid = stData.step4Data?.task_id || stData.reviewTaskId
    const ok = await rejectSession(tid)
    setShowCancelModal(false)
    if (ok) {
      window.location.reload()
    }
  }

  // "Hoàn tác nhập liệu" ở bước 6: xóa bản ghi mới + khôi phục bản ghi cũ → ROLLED_BACK.
  // Đợi API rollback phản hồi → gọi session/active kiểm tra lại → về bước 1 (task_id đã bị xóa).
  const rollbackImport = async () => {
    const tid = stData.step4Data?.task_id || stData.reviewTaskId
    if (!tid || sessionActionLoading) return
    setSessionActionLoading(true)
    try {
      await mixPostV3('/import/file_import_rollback', { task_id: tid, admin_id: user.id }, { skipVehicleBrand: true })
      // Kiểm tra lại phiên sau hoàn tác — nếu còn phiên active, banner ở bước 1 sẽ tự hiển thị
      try {
        const ses = await mixGetV3('/import/file_import_session/active', { admin_id: user.id }, { skipVehicleBrand: true })
        setActiveSession(ses && ses.has_active ? ses : null)
      } catch (e) {
        setActiveSession(null)
      }
      setShowRollbackModal(false)
      setSessionActionLoading(false)
      pushToast("Đã hoàn tác dữ liệu phiên nhập liệu.", "success")
      // Về bước 1 với trạng thái sạch — task_id đã bị xóa, bắt đầu phiên nhập liệu mới
      setStData((prev: any) => ({
        ...prev,
        dataFiles: [],
        priorityFiles: [],
        tempParams: {},
        filesParams: {},
        resData: {},
        task_id: '',
        reviewTaskId: '',
        reviewFiles: [],
        reviewTotalInvalid: 0,
        step4Data: {},
        step4DataSelected: {},
        obCheckRadioStep4: {},
        listSelectStep4: [],
        step5Data: {},
        loading: false,
      }))
      setCurrentStep(0)
    } catch (e) {
      pushToast("Đã có lỗi xảy ra khi hoàn tác dữ liệu.", "error")
      setSessionActionLoading(false)
    }
  }

  const upHistory = async () => {
    const params = { admin_id: user.id } as any
    stData.dataFiles.map((val: any, index: number) => {
      params[`file_${index + 1}`] = val.file
    })
    await mixPostV2('/api/v1/be/history_file', params, { skipVehicleBrand: true })
  }

  const [listTemplate, setListTemplate] = useState([] as any)
  const [paramTemplate, setParamTemplate] = useState({
    'sort[]': 'id,desc',
    page: 1,
    limit: 100000,
    name: '',
  })
  let wait = false
  const getTemplate = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/history_files', paramTemplate)
    wait = false
    if (res.status) {
      const items = res.data.items.map((val: any) => ({ name: val.name, date: mixDate(val.created_at), user: 'Admin' }))
      setStData((prev: any) => ({ ...prev, importHistory: items }))
    }
  }

  useEffect(() => {
    getTemplate()
  }, [paramTemplate])

  const nextStep = () => {
    const next = currentStep + 1;
    if (next === 1) {
      if (activeSession?.has_active) {
        pushToast("Bạn đang có một phiên nhập liệu chưa hoàn tất, vui lòng tiếp tục hoặc hủy phiên nhập liệu trước khi import tệp mới.", "warning");
        return;
      }
      if (stData.dataFiles.length === 0) {
        pushToast("Vui lòng tải lên ít nhất một file để tiếp tục.", "warning");
        return;
      }
      const sumSize = stData.dataFiles.reduce((acc: number, file: any) => acc + file.size, 0);
      if (sumSize > 15 * 1024 * 1024) {
        pushToast("Tổng dung lượng file vượt quá 15MB. Vui lòng kiểm tra lại.", "warning");
        return;
      }
      const errors = stData.dataFiles.filter((file: any) => file.error.length > 0);
      if (errors.length > 0) {
        pushToast(`Có ${errors.length} file không hợp lệ.`, "warning");
        return;
      }
      setCurrentStep(next);
    }
    if (next === 2) {
      setCurrentStep(next);
    }
    if (next === 3) {
      importReviewData();
    }
    if (next === 4) {
      if (stData.reviewIsSkippable === false) {
        pushToast("Dữ liệu chứa lỗi bắt buộc phải xử lý. Vui lòng kiểm tra và sửa lỗi trước khi tiếp tục.", "error");
        return;
      }
      if (stData.reviewTotalInvalid > 0 && !skipConfirm) {
        setShowConfirmModal(true);
        return;
      }
      importData();
    }
    if (next === 5) {
      // Không chặn cứng theo can_confirm — backend là nơi quyết định khi POST confirm
      // (nếu phiên chưa sẵn sàng, POST /import/file_import_result/json sẽ trả lỗi và FE hiện toast)
      importDataSave();
    }
  };
  const handleConfirmSkipErrors = () => {
    setShowConfirmModal(false);
    importData();
  };

  return (
    <>
      <Modal
        open={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        footer={null}
        centered
        className="confirm-skip-errors-modal"
      >
        <div className="confirm-modal-body">
          <h3 className="confirm-modal-title">Bạn có chắc chắn bỏ qua dữ liệu khách hàng lỗi?</h3>
          <div className="confirm-modal-icon">
            <svg width="70" height="62" viewBox="0 0 70 62" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M69.666 57.5L37.166 1.25C36.6817 0.414063 35.8457 0 35.002 0C34.1582 0 33.3145 0.414063 32.8379 1.25L0.337917 57.5C-0.62302 59.1719 0.580104 61.25 2.50198 61.25H67.502C69.4238 61.25 70.627 59.1719 69.666 57.5ZM32.502 23.125C32.502 22.7812 32.7832 22.5 33.127 22.5H36.877C37.2207 22.5 37.502 22.7812 37.502 23.125V37.5C37.502 37.8438 37.2207 38.125 36.877 38.125H33.127C32.7832 38.125 32.502 37.8438 32.502 37.5V23.125ZM35.002 50.625C34.0207 50.605 33.0863 50.2011 32.3994 49.5C31.7125 48.7989 31.3277 47.8565 31.3277 46.875C31.3277 45.8935 31.7125 44.9511 32.3994 44.25C33.0863 43.5489 34.0207 43.145 35.002 43.125C35.9833 43.145 36.9176 43.5489 37.6046 44.25C38.2915 44.9511 38.6762 45.8935 38.6762 46.875C38.6762 47.8565 38.2915 48.7989 37.6046 49.5C36.9176 50.2011 35.9833 50.605 35.002 50.625V50.625Z" fill="#F5222D"/> </svg>
          </div>
          <p className="confirm-modal-desc">
            Bạn đang chọn tiến hành tiếp theo trong khi hệ thống phát hiện <strong>{stData.reviewTotalInvalid} bản ghi dữ liệu lỗi</strong>. Nếu tiếp tục, hệ thống sẽ không được import vào hệ thống. Chúng tôi khuyến bạn nên tải file lỗi và cập nhật dữ liệu trước khi tiếp tục
          </p>
          <Checkbox
            checked={skipConfirm}
            onChange={(e) => setSkipConfirm(e.target.checked)}
            className="confirm-modal-checkbox"
          >
            Không thông báo nhắc lại lần sau
          </Checkbox>
        </div>
        <div className="confirm-modal-footer">
          <div className="btn-close btn-32-px-16" onClick={() => setShowConfirmModal(false)}>Huỷ</div>
          <div className="btn-next btn-32-px-16" onClick={handleConfirmSkipErrors}>Tiếp tục</div>
        </div>
      </Modal>
      <Modal
        open={showCancelModal}
        onCancel={() => setShowCancelModal(false)}
        footer={null}
        centered
        className="confirm-skip-errors-modal"
      >
        <div className="confirm-modal-body">
          <h3 className="confirm-modal-title">Bạn có chắc chắn hủy phiên nhập liệu?</h3>
          <div className="confirm-modal-icon">
            <ExclamationCircleFilled style={{ fontSize: 56, color: '#F5222D' }} />
          </div>
          <p className="confirm-modal-desc">
            Toàn bộ dữ liệu đã xử lý trong phiên nhập liệu này sẽ bị hủy và <strong>không được ghi vào hệ thống</strong>. Sau khi hủy, bạn sẽ được đưa về bước Tải file excel để bắt đầu phiên nhập liệu mới.
          </p>
        </div>
        <div className="confirm-modal-footer">
          <div className="btn-close btn-32-px-16" onClick={() => setShowCancelModal(false)}>Đóng</div>
          <div className="btn-next btn-32-px-16" onClick={handleCancelCurrentSession}>{sessionActionLoading ? <Spin /> : 'Hủy phiên'}</div>
        </div>
      </Modal>
      <Modal
        open={showRollbackModal}
        onCancel={() => { if (!sessionActionLoading) setShowRollbackModal(false) }}
        footer={null}
        centered
        closable={!sessionActionLoading}
        maskClosable={!sessionActionLoading}
        className="confirm-skip-errors-modal"
      >
        <div className="confirm-modal-body">
          <h3 className="confirm-modal-title">Bạn có chắc chắn hoàn tác dữ liệu?</h3>
          <div className="confirm-modal-icon">
            <ExclamationCircleFilled style={{ fontSize: 56, color: '#F5222D' }} />
          </div>
          <p className="confirm-modal-desc">
            Hệ thống sẽ xoá toàn bộ dữ liệu bạn vừa xử lý trong phiên nhập liệu này. Hành động này <strong>không thể hoàn tác lại</strong>. Sau khi hoàn tất, hệ thống sẽ đưa bạn trở về bước Tải file Excel để thực hiện nhập liệu lại.
          </p>
          {sessionActionLoading && (
            <p className="confirm-modal-desc" style={{ color: '#1677ff', fontWeight: 600 }}>
              Đang hoàn tác dữ liệu, vui lòng không đóng trang…
            </p>
          )}
        </div>
        <div className="confirm-modal-footer">
          {!sessionActionLoading && (
            <div className="btn-close btn-32-px-16" onClick={() => setShowRollbackModal(false)}>Hủy</div>
          )}
          <div className="btn-next btn-32-px-16" onClick={rollbackImport}>{sessionActionLoading ? <Spin /> : 'Hoàn tác'}</div>
        </div>
      </Modal>
      <Layout className='customer-list customers-mi'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/customer/list">Khách hàng</Link>, },
            { title: <Link to="/customer/pooling-data/customer-list">Danh sách khách hàng đã được làm sạch</Link>, },
            { title: 'Nhập danh sách', },
          ]}
          title='Nhập danh sách'
          backLink='/customer/pooling-data/customer-list'
          className='gutter-block-end'
        />
        <div className="pl-24">
          <Steps
            current={currentStep}
            type="navigation"
            items={[
              {
                title: 'Tải file excel',
              },
              {
                title: 'Thiết lập dữ liệu',
              },
              {
                title: 'Xem trước dữ liệu',
              },
              {
                title: 'Kiểm tra dữ liệu cần xử lý',
              },
              {
                title: 'Xác nhận dữ liệu',
              },
              {
                title: 'Kết quả',
              },
            ]}
            className='rs-steps'
          />
          {currentStep === 0 && activeSession?.has_active && (
            <div style={{ margin: '16px 0 0', border: '1px solid #ffccc7', background: '#fff2f0', borderRadius: 8, padding: '12px 16px' }}>
              <div style={{ color: '#cf1322', fontWeight: 600, marginBottom: 10, display: 'flex', gap: 8 }}>
                <ExclamationCircleFilled style={{ marginTop: 3 }} />
                <span>Bạn đang có một phiên nhập liệu chưa hoàn tất, vui lòng tiếp tục hoặc hủy phiên nhập liệu trước khi import tệp mới.</span>
              </div>
              {(((activeSession.sessions && activeSession.sessions.length > 0) ? activeSession.sessions : [{}]) as any[]).map((ses: any, idx: number) => (
                <div key={idx} style={{ background: '#fff', border: '1px solid #f0f0f0', borderRadius: 8, padding: '10px 14px', marginBottom: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontWeight: 600, flex: 1 }}>Phiên nhập liệu đang xử lý</span>
                    <div className="btn-next btn-32-px-16" style={{ cursor: 'pointer' }} onClick={() => resumeSession()}>
                      {sessionActionLoading ? <Spin size="small" /> : 'Tiếp tục'}
                    </div>
                    <div className="btn-close btn-32-px-16" style={{ cursor: 'pointer', color: '#cf1322' }} onClick={() => rejectSession(activeSession.task_id)}>Hủy</div>
                  </div>
                  {(ses.step_label || ses.message) && (
                    <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 6 }}>{ses.step_label}{ses.step_label && ses.message ? ' — ' : ''}{ses.message}</div>
                  )}
                  {(ses.progress_percent || ses.progress_percent === 0) && (
                    <div style={{ height: 6, background: '#f0f0f0', borderRadius: 999, overflow: 'hidden', marginTop: 8 }}>
                      <div style={{ height: '100%', width: `${Number(ses.progress_percent) || 0}%`, background: '#1677ff', borderRadius: 999 }} />
                    </div>
                  )}
                  {Array.isArray(ses.files) && ses.files.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                      {ses.files.map((f: any, i: number) => (
                        <span key={i} style={{ fontSize: 12, border: '1px solid #f0f0f0', borderRadius: 6, padding: '2px 8px', color: '#595959' }}>
                          {typeof f === 'string' ? f : (f.name || f.filename || '')}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {currentStep === 0 && (
            <Step1 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep === 1 && (
            <Step2 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep === 2 && (
            <Step3 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep === 3 && (
            <Step4 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep === 4 && (
            <Step5 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep === 5 && (
            <Step6 stData={stData} onChange={(data, type) => {
              if (!type) {
                setStData((prev: any) => ({ ...prev, ...data }));
              }
            }} />
          )}
          {currentStep < 5 && (
            <div className="ctrl-btnn-footer">
              {currentStep === 4 && (
                <div className="btn-close btn-32-px-16" style={{ color: '#cf1322', borderColor: '#ffa39e' }} onClick={() => setShowCancelModal(true)}>Hủy</div>
              )}
              {
                currentStep > 0 ?
                  <div className="btn-close btn-32-px-16" onClick={() => setCurrentStep(currentStep - 1)}>Quay lại</div>
                  : <div className="btn-close btn-32-px-16" onClick={() => navigate('/customer/pooling-data/customer-list')}>Đóng</div>
              }
              <div className="btn-next btn-32-px-16" onClick={() => nextStep()}>{stData.loading ? <Spin /> : 'Tiếp theo'}</div>
            </div>
          )}
          {currentStep === 5 && (
            <div className="ctrl-btnn-footer">
              <div className="btn-close btn-32-px-16" style={{ color: '#cf1322', borderColor: '#ffa39e' }} onClick={() => setShowRollbackModal(true)}>Hoàn tác nhập liệu</div>
              <div className="btn-close btn-32-px-16" onClick={() => {
                window.location.reload();
              }}>Import thêm</div>
              <div className="btn-next btn-32-px-16" onClick={() => navigate('/customer/pooling-data/customer-list')}>Đóng</div>
            </div>
          )}
        </div>
      </Layout>
    </>
  )
}

export default AddAgencyModal
